'use client';

import useDynamicTranslation from '@/hooks/useDynamicTranslation';
import { RootState } from '@/store';
import Image from 'next/image';
import Link from 'next/link';
import { useSelector } from 'react-redux';

export default function AboutPage() {
  const { dt } = useDynamicTranslation();
  const { general } = useSelector((state: RootState) => state.settings);

  return (
    <div
      className="container-fluid"
      style={{ backgroundColor: 'var(--body-bg)' }}
    >
      <div className="page-content">
        <ul className="ps-breadcrumb">
          <li className="ps-breadcrumb__item">
            <Link href="/">{dt('home')}</Link>
          </li>
          <li className="ps-breadcrumb__item active" aria-current="page">
            {dt('about_us')}
          </li>
        </ul>

        <div className="about-page">
          <div className="content">
            <div
              style={{
                position: 'relative',
                width: '100%',
                aspectRatio: '5/2',
              }}
            >
              <Image
                fill
                className="about-img"
                src={general.about_us_banner}
                loading="lazy"
                alt="About us banner"
                style={{ objectFit: 'cover' }}
              />
            </div>
            <div className="mt-5">
              <h1 className="ps-page-name">{dt('about_company')}</h1>
              <p dangerouslySetInnerHTML={{ __html: general.about_us }}></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
